import { performRequest } from "../performRequest"



export const getAllUniformsApi = (params) => {
    return performRequest("get", "api/ess/uniform/",params)
}

export const getUniformDetailApi = (id, params) => {
    return performRequest("get", `api/ess/uniform/${id}/`,params)
}


export const postUniformApi = (params) => {
    const company = localStorage.getItem('company') || 1

    params['company'] = company

    return performRequest("post", `api/ess/uniform/`,params)
}

export const updateUniformApi = (id, params) => {
    const company = localStorage.getItem('company') || 1

    params['company'] = company
    
    return performRequest("put", `api/ess/uniform/${id}/`,params)
}


export const uniformAllocation = (params) => {
    // const company = localStorage.getItem('company') || 1

    // params['company'] = company
    
    return performRequest("post", `/api/ess/uniform/allocation/`, params)
}
// export const deleteUniformApi = (id) => {
//     const company = localStorage.getItem('company') || 1    
//     return performRequest("delete", `api/ess/uniforms/${id}/`)
// }



export const getUniformsApi = (params) => {
    return performRequest("get", "api/ess/uniform-all/",params)
}



export const getUniformsAllocationApi = (params) => {
    return performRequest("get", "api/ess/uniform/user/",params)
}



export const updateUniformsAllocationApi = (id, params) => {
    return performRequest("patch", `/api/ess/uniform/allocation/${id}/`,params)
}


export const getUniformStockApi = (params) => {
    return performRequest("get", "api/ess/uniform/stock/", params)
}


export const addUniformStockApi = (params) => {
    return performRequest("post", "/api/ess/uniform/stock/take/", params)
}


export const getUniformStockSummaryApi = (params) => {
    return performRequest("get", "/api/ess/uniform/stock-summary/", params)
}
